// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SIGNUP_PHONE_WE_SENT_YOU_NEW_ACTIVATION_CODE_SMS = "Poslali jsme ti nov\u00fd aktiva\u010dn\u00ed k\u00f3d.";
export const YOU_WERE_SUCCESSFULLY_LOGGED_IN_AS_username = "Pr\u00e1v\u011b jsi se p\u0159ihl\u00e1sila jako u\u017eivatelka %(username)s.";
